import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';
import { classNames } from 'uitk-react-utils';
export interface LeadPriceProps {
  lead?: string;
  label?: string;
  priceFontWeight: string;
  wrapPrice: boolean;
  strikeOut?: string;
}

export const LeadPrice: React.FunctionComponent<LeadPriceProps> = ({ lead, label, priceFontWeight, wrapPrice, strikeOut }) => {
  if (!lead) {
    return null;
  } else {
    const classes = classNames(`uitk-cell uitk-type-${priceFontWeight} uitk-type-bold`, {
      ['all-cell-shrink']: !wrapPrice,
      ['m-cell-shrink l-cell-shrink xl-cell-shrink']: wrapPrice
    });

    return (
      <span className={`${classes}`} data-stid="content-hotel-display-price">
        <span className="is-visually-hidden">
          <LocalizedText
            message={strikeOut ? 'hotels.infosite.rateInfoDialog.leadWithStrikeOutPresent' : 'hotels.infosite.rateInfoDialog.lead'}
            data={[lead]}
          />
        </span>
        <span data-stid="content-hotel-lead-price" aria-hidden="true">
          {lead}
        </span>
        {label && (
          <span className="uitk-type-400 uitk-type-regular pwa-theme--grey-900" data-stid="lead-price--text">
            {label}
          </span>
        )}
      </span>
    );
  }
};
